import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DatePicker.scss';
import cn from 'classnames';
import { ButtonSpinner } from '../../../common/ButtonSpinner/ButtonSpinner';

const generateDates = (startDate, data) => {
  const dates = [];
  const baseDate = new Date(startDate);

  for (let i = 0; i < 5; i++) {
    const day = new Date(baseDate);
    day.setDate(baseDate.getDate() + i);

    const dayString = day.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const slots = data[dayString] || [];

    dates.push({
      weekDay: day.toLocaleDateString('ru-RU', { weekday: 'short' }),
      monthDay: day.getDate(),
      isAvailable: slots.length > 0,
      slots: slots.map((time) => ({
        from: time,
      })),
    });
  }

  return dates;
};

const DatePicker = ({ data, onTabChange, activeTab, isLoading, selectedSlot, onSelectSlot }) => {
  const { t } = useTranslation();

  const firstDateKey = data && Object.keys(data)[0];
  const startDate = firstDateKey
    ? new Date(firstDateKey.split('.').reverse().join('-'))
    : new Date();

  const dates = generateDates(startDate, data);
  const [activeDate, setActiveDate] = useState(startDate.getDate());

  const handleChangeTab = (tab) => {
    if (tab !== activeTab) {
      onTabChange(tab);
      onSelectSlot();
      setActiveDate(startDate.getDate());
    }
  };

  const handleDateSelect = (day) => {
    setActiveDate(day.monthDay);
    onSelectSlot();
  };

  const selectedDate = dates.find((date) => date.monthDay === activeDate);
  const hasSlots = selectedDate && selectedDate.slots.length > 0;

  return (
    <div className={styles.DatePicker}>
      <div className={styles.Tabs}>
        <button
          className={cn(styles.TabButton, { [styles.Active]: activeTab === 'offline' })}
          onClick={() => handleChangeTab('offline')}
        >
          ОФФЛАЙН
        </button>
        <button
          className={cn(styles.TabButton, { [styles.Active]: activeTab === 'online' })}
          onClick={() => handleChangeTab('online')}
        >
          ОНЛАЙН
        </button>
      </div>
      {isLoading ? (
        <div className={styles.LoadingSkeleton}>
          <ButtonSpinner />
        </div>
      ) : (
        <div className={styles.Calendar}>
          <div className={styles.Dates}>
            {dates.map((item) => (
              <div className={styles.Date} key={item.monthDay}>
                <div className={styles.WeekDay}>{item.weekDay}</div>
                <div
                  className={cn(styles.MonthDay, {
                    [styles.Available]: item.isAvailable && activeDate !== item.monthDay,
                    [styles.Selected]: activeDate === item.monthDay,
                  })}
                  onClick={() => handleDateSelect(item)}
                >
                  {item.monthDay}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.Slots}>
            <div className={styles.SlotsTitle}>
              {hasSlots ? (
                t('components.appointment.appointmentDialog.availableSlots')
              ) : (
                <div className={styles.NoSlots}>
                  <p className={styles.NoSlotsTitle}>
                    {t('components.appointment.appointmentDialog.noAvailableSlotsTitle')}
                  </p>
                  <p className={styles.NoSlotsSubtitle}>
                    {t('components.appointment.appointmentDialog.noAvailableSlotsSubtitle')}
                  </p>
                </div>
              )}
            </div>
            {hasSlots && (
              <div className={styles.SlotTable}>
                {selectedDate.slots.map((slot, index) => (
                  <div
                    className={cn(styles.Slot, {
                      [styles.Selected]: selectedSlot && selectedSlot.from === slot.from,
                    })}
                    key={index}
                    onClick={() => {
                      const formattedDate = `${String(activeDate).padStart(2, '0')}.${String(
                        startDate.getMonth() + 1
                      ).padStart(2, '0')}.${startDate.getFullYear()}`;
                      onSelectSlot(formattedDate, slot);
                    }}
                  >
                    {slot.from}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/Appointment/AppointmentDialog/DatePicker/DatePicker.jsx